/**
 * The button that shuts a window.
 *
 * One component rather than four copies, because it sits inside a drag handle and
 * has to keep working there: the header captures the pointer to move the window,
 * and anything inside it has to be recognisable as a control rather than a grip.
 */

export function CloseButton({ onClose }: { onClose: () => void }): JSX.Element {
  return (
    <button type="button" className="trade-close" onClick={onClose} title="Close">
      <span className="close-mark">✕</span>
    </button>
  );
}
